import { Box, Divider, Typography, useTheme } from "@mui/material";
import React from "react";

const FormSectionDivider = ({ title, subtitle }) => {
  const theme = useTheme();
  return (
    <div>
      <Box sx={{ display: "flex", alignItems: "flex-end" }}>


        <Typography
          variant="h6"
          sx={{ color: theme.palette.primary.main, marginTop: 5, display: "inline-block" }}>
          {title}
        </Typography>
        {!!subtitle && (
          <Typography
            sx={{ fontWeight: 'bold', display: "inline-block", flexGrow: 1, textAlign: "center" }}
            variant="subtitle2"
            color="error">
            {subtitle}
          </Typography>
        )}
      </Box>
      <Divider
        sx={{
          backgroundColor: theme.palette.primary.main,
          padding: "1px",
          borderRadius: 20,
        }}
      />
    </div>
  );
};

export default FormSectionDivider;
